import { RouteComponentProps } from "@reach/router"
import { ApiError, DocumentTitleOverride, Flex } from "@shared/primitive-components"
import { useFleetInsights } from "../../../api/insights/fleet/useGetPeriods"
import { ScreenContentWithContext } from "../../../components/ScreenContentWithContext"
import { usePolicyAccessCapabilities } from "../../../hooks"
import { PrevPolicyDropdown, SummaryChartCard } from "../../components"
import {
  FleetGauge,
  SafetyScoreOverviewChart,
  WorstScoringVehiclesTable,
} from "../../components/SafetyInsightsComponents"

export const SafetyOverview: React.FC<RouteComponentProps> = () => {
  const { isRebatePolicy } = usePolicyAccessCapabilities()
  const { apiErrored, data, loading } = useFleetInsights()

  if (apiErrored) return <ApiError />

  const safetyScoreHistoryTooltip = isRebatePolicy
    ? `Starting Safety Score is calculated after 30 days of telematics data collection. As your Safety Score increases above your Starting Safety Score, you can accumulate up to 4% more rebate.`
    : `Starting Safety Score is calculated after 30 days of telematics data collection.`

  return (
    <>
      <DocumentTitleOverride>Flock Motor | Safety Score </DocumentTitleOverride>
      <ScreenContentWithContext title="Safety Overview" PreviousPolicyDropdown={<PrevPolicyDropdown />}>
        <SummaryChartCard
          summary={
            <FleetGauge
              title="Policy Safety Score"
              tooltip="Policy safety scores are calculated by looking at vehicle and trip scores for the period of the policy weighted by mileage. Higher scores are given for safer driving."
              score={data?.total?.safetyScore ?? null}
              loading={loading}
            />
          }
          chart={<SafetyScoreOverviewChart />}
          chartTitle="Safety Score History"
          chartTooltip={safetyScoreHistoryTooltip}
          isGridEqual={false}
        />
        <Flex>
          <WorstScoringVehiclesTable />
        </Flex>
      </ScreenContentWithContext>
    </>
  )
}
